import { ApplicationStage } from '@standardnotes/services';
import { Migration } from '@Lib/Migrations/Migration';
import { ContentType } from '@standardnotes/domain-core';
const NoDistractionIdentifier = 'org.standardnotes.theme-no-distraction';
export class Migration2_42_0 extends Migration {
    static version() {
        return '2.42.0';
    }
    registerStageHandlers() {
        this.registerStageHandler(ApplicationStage.FullSyncCompleted_13, async () => {
            await this.deleteNoDistraction();
            this.markDone();
        });
    }
    async deleteNoDistraction() {
        const themes = this.services.itemManager.getItems(ContentType.TYPES.Theme).filter((theme) => {
            return theme.identifier === NoDistractionIdentifier;
        });
        for (const theme of themes) {
            await this.services.mutator.setItemToBeDeleted(theme);
        }
    }
}
